import { memo } from 'react';

import { connect } from 'react-redux';
import { compose } from 'recompact';

import { ANALYTICS_CLICK_EVENTS } from 'src/app/analytics/analyticsEvents';
import { errorBoundary } from 'src/app/hocs';
import { segmentAnalyticsClick } from 'src/app/state/actions';
import { getPrimaryPatientId } from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';

import Renderer from '.';

function makeMapStateToProps() {
  return (state: RootState) => {
    return {
      primaryPatientId: getPrimaryPatientId(state),
    };
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  sectionExpanded: (questions, index) =>
    dispatch(segmentAnalyticsClick(`${ANALYTICS_CLICK_EVENTS.transferFaqPrefix}${questions[index].question}`)),
});

export default compose(errorBoundary, connect(makeMapStateToProps, mapDispatchToProps), memo)(Renderer);
